import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'redux-zero/react';
import { FormattedMessage, injectIntl } from 'react-intl';
import qs from 'query-string';

import NoDataComponent from '../../components/no-data-component/no-data.js';
import NewsCard from './news-card.component.js';
import Pagination from './pagination.component.js';
import NewsService from './news.service.js';
import { actions } from '../../shared/store.js';
import { MainTitle } from '../../components/ui-toolkit/typography.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import Seo from '../../infrastructure/seo.js';
import ScrollToTop from '../../shared/utils.js';

import './news-details.scss';

const limit = 9;

class NewsListPageInternal extends Component {
	static prefetchData = async (language, page) => NewsService.getNews({ lang: language, limit, skip: (page - 1) * limit });

	state = {
		hasError: false,
	};

	componentDidMount() {
		ScrollToTop();
		if (!this.props.news) {
			const params = qs.parse(this.props.location.search);
			this.fetchNews(params.page);
		} else {
			this.props.setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		ScrollToTop();
		if (
			this.props.language.value !== prevProps.language.value
			|| this.props.location.search !== prevProps.location.search
		) {
			const params = qs.parse(this.props.location.search);
			this.fetchNews(params.page);
		}
	}

	fetchNews(page = 0) {
		this.props.setLoading(true);
		NewsListPageInternal.prefetchData(this.props.language.value, page)
			.then((data) => {
				this.props.setNewsList(data.data);
				this.props.setTotalNews(data.total);
				this.props.setLoading(false);
			})
			.catch((error) => {
				this.props.setLoading(false);
				this.setState({
					hasError: true,
				});
				console.log(error);
			});
	}

	changePage = (page) => {
		const params = qs.parse(this.props.location.search);
		params.page = page;

		this.props.history.push({
			pathname: this.props.location.pathname,
			search: `?${qs.stringify(params)}`,
		});
	};

	render() {
		const {
			news,
			totalNews,
			location,
			intl: { formatMessage },
			addresses,
			phones,
			generalData,
		} = this.props;

		const { hasError } = this.state;

		if (hasError) {
			return <NotImplemented title="News" />;
		}

		const params = qs.parse(location.search);
		let newsList = null;

		if (!news) {
			newsList = (
				<NoDataComponent
					title={formatMessage({ id: 'news-list.no-results.title' })}
					message={formatMessage({
						id: 'news-list.no-results.message',
					})}
					link="/"
					buttonLabel={formatMessage({ id: 'button.goToHome' })}
				/>
			);
		} else {
			newsList = (
				<div className="outside">
					<div className="rosa" />
					<div className="container container-fluid related-news">
						<div className="news">
							<div className="row">
								{news
									&& news.map(entry => <NewsCard key={entry.id} {...entry} />)}
							</div>
						</div>
						<div className="pagination">
							<div className="container container-fluid">
								<Pagination
									skip={params.page}
									total={totalNews}
									limit={limit}
									changeCallback={this.changePage}
								/>
							</div>
						</div>
					</div>
				</div>
			);
		}

		return (
			<div id="news">
				<Seo
					title={formatMessage({ id: 'news-list.title' })}
					description={formatMessage({ id: 'news-list.title' })}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										${news && news.length > 0 && `
											{
												"@type": "ItemList",
												"numberOfItems": ${totalNews},
												"itemListElement": [
												${news.map((item, i) => `
													{
														"@type": "ListItem",
														"position": ${i},
														"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/news/${item.slug}"
													}
												`)}
												]
											},
										`}
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.news' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/news"
												}
											]
										}
									]
								}`}
				/>
				<div className="container container-fluid">
					<MainTitle>
						<FormattedMessage id="news-list.title" />
					</MainTitle>
					<div className="row">{newsList}</div>
				</div>
			</div>
		);
	}
}

const mapToProps = ({ language, news, totalNews, addresses, phones, generalData }) => ({
	language,
	news,
	totalNews,
	addresses,
	phones,
	generalData,
});
export default connect(
	mapToProps,
	actions,
)(withRouter(injectIntl(NewsListPageInternal)));

export { NewsListPageInternal };
